import React, { useState, useEffect, useContext, useRef } from 'react';
import { Api, getSession, urlWithAccessToken, cancelRequest } from '../../../api/Assinafy';
import { Row, Col } from 'react-bootstrap';
import { Section } from '../../../layout'
import { SessionContext } from '../../../routes/DashboardRoute';
import { Input, Button, Dropzone, Icon, ColorPicker, Alert, Tooltip, Spinner } from '../../../components';
import Form, { createInputBlur, createInputError } from '../../../components/Form';
import { Prompt } from '../../../history';

import assinafyLogo from '../../../assets/images/assinafy-logo.svg';

const BrandTab = () => {
  const updateAccount = Api('account/update')
  const [theme, setTheme] = useState({})
  const [loading, setLoading] = useState(false)
  const [submitDisabled, setSubmitDisabled] = useState(true)
  const [errors, setErrors] = useState([])
  const [formError, setFormError] = useState([])
  const [formValidation, setFormValidation] = useState([])
  const [formData, setFormData] = useState({})
  const [tooltipShow, setTooltipShow] = useState(false)
  const [tooltip2Show, setTooltip2Show] = useState(false)
  const [themeLogo, setThemeLogo] = useState(false)
  const [session, setSession] = useContext(SessionContext)
  const cancelToken = cancelRequest()
  const currentAccount = getSession().accounts[0]
  const dropzoneRef = useRef()

  const handleColorPickerChange = (name, value) => {
    if (submitDisabled) {
      setSubmitDisabled(false)
    }

    return setFormData({
      ...formData,
      [name]: value
    })
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    if (event.target.checkValidity()) {
      setLoading(true)

      updateAccount(currentAccount.id, formData, () => {
        setSession(getSession())
      })
        .then(() => {
          setLoading(false)
          setSubmitDisabled(true)
        })
        .catch(({ response }) => {
          if (response) {
            setFormError([response.data.message])
          }

          setLoading(false)
          setSubmitDisabled(true)
        })
    } else {
      Array.from(event.target.elements).map((element) => {
        if (element.name) {
          setFormValidation((prevState) => [
            ...prevState,
            { name: element.name, message: element.validationMessage }
          ])
        }
      })
    }
  }

  const handleDropzoneSubmit = (formData) => {
    setThemeLogo(false)

    return new Promise((resolve, reject) => {
      return Api('account/uploadLogo')(currentAccount.id, formData)
        .then(({ status }) => {
          if (status === 200) {
            Api('account/theme')(currentAccount.id, {
              ...cancelToken.config
            }).then(response => {
              const { data: { data } } = response
              setTheme((prevState) => {
                return { ...prevState, logo: data.logo }
              })
              resolve(response)
            }).catch(error => {
              reject(error)
            })
          }
        })
    })
  }

  const handleAlertClose = () => {
    setFormError([]);
    dropzoneRef.current.clearErrors();
  }

  const handleLogoRemove = () => {
    setThemeLogo(false)

    Api('account/deleteLogo')(currentAccount.id)
      .then(({ status }) => {
        if (status === 200) {
          setTheme({ ...theme, logo: null });
          setThemeLogo(assinafyLogo);

          dropzoneRef.current.removeAll();
        }
      })
  }

  const handleChange = (event) => {
    if (submitDisabled) {
      setSubmitDisabled(false)
    }

    setFormData({
      ...formData,
      [event.target.name]: event.target.value
    })
  }

  const handleBlur = createInputBlur(formValidation, setFormValidation)

  const showInputError = createInputError(formValidation)

  useEffect(() => {
    if (!currentAccount) {
      setErrors(['Você precisa estar em um workspace'])
      return
    }

    Api('account/theme')(currentAccount.id, {
      ...cancelToken.config
    }).then(({ data: { data } }) => {
      setTheme(data)

      if (data.logo) {
        setThemeLogo(urlWithAccessToken(data.logo))
      } else {
        setThemeLogo(assinafyLogo)
      }
    })
      .catch(({ response }) => {
        if (response) {
          setErrors([response.data.message])
        }
      })

    return () => {
      cancelToken.cancel()
    }
  }, [])

  if (errors.length) {
    return (
      <Alert show={errors.length} variant="danger">
        {errors.map((error) => error)}
      </Alert>
    )
  }

  return (<>
    <Form id="form-account"
      onSubmit={handleSubmit}
    >
      <Alert show={formError.length} variant="warning" onClose={handleAlertClose}>
        {formError.map((error) => error)}
      </Alert>

      <Row>
        <Col lg="6">
          <Section className="section-workspace">
            <Section.Header
              title="Configure o branding da sua comunicação"
              titleAs="h3"
            />
            <Row>
              <Col lg="7">
                <Form.Group className="mb-0">
                  <Input label="Nome workspace"
                    name="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    defaultValue={theme.account_name}
                    size="lg"
                    disabled={!updateAccount}
                    required
                  />
                  {showInputError('name')}
                </Form.Group>
              </Col>
            </Row>
          </Section>

          <Section className="section-workspace">
            <Section.Header
              title="Logotipo"
              titleAs="h4"
              opening="Essa logo será utilizada nos e-mails enviados e na página de assinatura."
            />
            <Form.Group className="group-dropzone">
              <Input.Group>
                <Dropzone.Inline
                  ref={dropzoneRef}
                  errorsCallback={(errors) => { setFormError(errors) }}
                  acceptedExts={{
                    'image/jpg': ['.jpg'],
                    'image/jpeg': ['.jpeg'],
                    'image/png': ['.png']
                  }}
                  maxFilesize={1048576}
                  maxHeight={64}
                  maxWidth={300}
                  onSubmit={handleDropzoneSubmit}
                  onRemove={() => handleLogoRemove()}
                  disabled={!updateAccount}
                >
                  {themeLogo
                    ? <img src={themeLogo} className="dz-preview-bg" alt="" />
                    : <Spinner />
                  }
                </Dropzone.Inline>
                {(Api('account/deleteLogo') && theme.logo) &&
                  <Button variant="icon" className="btn-remove"
                    onMouseEnter={() => setTooltip2Show(true)}
                    onMouseLeave={() => setTooltip2Show(false)}
                    onClick={handleLogoRemove}
                  >
                    <Icon id="icon-close" size="24" />
                    <Tooltip show={tooltip2Show}>
                      Excluir
                    </Tooltip>
                  </Button>
                }
              </Input.Group>
              <Form.Text>
                Escolha uma foto PNG, JPG ou JPEG até 1 mb ou veja as <span
                  className="text-info text-accepted-files"
                  onMouseEnter={() => setTooltipShow(true)}
                  onMouseLeave={() => setTooltipShow(false)}
                >
                  boas práticas
                  <Tooltip show={tooltipShow}>
                    <ul>
                      <li>Tamanho máximo de 1 mb</li>
                      <li>Dimensões recomendadas: 300 x 64 pixels</li>
                      <li>Formatos suportados: PNG, JPG e JPEG</li>
                    </ul>
                  </Tooltip>
                </span>.
              </Form.Text>
              {updateAccount && <Button variant="info" size="sm"
                onClick={() => dropzoneRef.current.open()}
              >
                <Icon id="icon-add" className="me-1" size="16" />
                ADICIONAR LOGO
              </Button>}
            </Form.Group>
          </Section>

          <Section className="section-workspace">
            <Section.Header
              title="Cores"
              titleAs="h4"
              opening="Selecione quais cores que você deseja usar no botão dos e-mails"
            />
            <ColorPicker title="Texto de botão"
              defaultValue={theme.secondary_color}
              onChange={(color) => handleColorPickerChange('secondary_color', color)}
              disabled={!updateAccount}
            />
            {showInputError('secondary_color')}
            <ColorPicker title="Fundo de botão"
              defaultValue={theme.primary_color}
              onChange={(color) => handleColorPickerChange('primary_color', color)}
              disabled={!updateAccount}
            />
            {showInputError('primary_color')}
          </Section>
        </Col>
        <Col lg={{ span: 6 }} xl={{ span: 5, offset: 1 }}>
          <ThemePreview
            textColor={formData.secondary_color || theme.secondary_color}
            bgColor={formData.primary_color || theme.primary_color}
          />
        </Col>
      </Row>
      {updateAccount && <Button variant="primary"
        submit
        loading={loading}
        disabled={submitDisabled}
      >
        APLICAR WORKSPACE
      </Button>}
    </Form>
    <Prompt
      when={submitDisabled === false}
      message="As alterações que você fez podem não ser salvas."
    />
  </>)
}

const ThemePreview = ({ textColor, bgColor }) => {
  const [type, setType] = useState('email')

  return (
    <div className="theme-preview">
      <div className="theme-preview-header">
        <b>Pré-visualização</b>
        <button type="button" className={`btn${type === 'email' ? ' active' : ''}`}
          onClick={() => setType('email')}
        >
          <Icon id="icon-mail" className="me-1" size="14" />
          E-mail
        </button>
        <button type="button" className={`btn${type === 'sign' ? ' active' : ''}`}
          onClick={() => setType('sign')}
        >
          <Icon id="icon-monitor" className="me-1" size="14" />
          Página de assinatura
        </button>
      </div>

      {type === 'sign'
        ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 402 306" width="402">
          <g clipPath="url(#a)">
            <rect width="402" height="306" fill="#F5F7FB" rx="3" />
            <g clipPath="url(#b)">
              <path fill="#fff" d="M0 0h402v36H0z" />
              <path fill="#fff"
                d="M19.82 24.667a6.22 6.22 0 0 1-2.541-.526 6.571 6.571 0 0 1-2.07-1.424 6.738 6.738 0 0 1-1.392-2.117 6.616 6.616 0 0 1-.514-2.6c0-.922.171-1.789.514-2.6a6.739 6.739 0 0 1 1.393-2.117 6.58 6.58 0 0 1 2.069-1.425 6.226 6.226 0 0 1 2.541-.525c.901 0 1.749.175 2.541.525.793.35 1.483.825 2.07 1.425.586.6 1.05 1.306 1.392 2.117.343.811.514 1.678.514 2.6 0 .922-.171 1.789-.514 2.6a6.738 6.738 0 0 1-1.392 2.117 6.57 6.57 0 0 1-2.07 1.424 6.22 6.22 0 0 1-2.541.526Z" />
              <path fill="#8C97A0"
                d="m18.908 21.067 4.594-4.7-.912-.934-3.682 3.767-1.858-1.9-.912.933 2.77 2.834Zm.912 3.6a6.22 6.22 0 0 1-2.541-.526 6.571 6.571 0 0 1-2.07-1.424 6.738 6.738 0 0 1-1.392-2.117 6.616 6.616 0 0 1-.514-2.6c0-.922.171-1.789.514-2.6a6.739 6.739 0 0 1 1.393-2.117 6.58 6.58 0 0 1 2.069-1.425 6.226 6.226 0 0 1 2.541-.525c.901 0 1.749.175 2.541.525.793.35 1.483.825 2.07 1.425.586.6 1.05 1.306 1.392 2.117.343.811.514 1.678.514 2.6 0 .922-.171 1.789-.514 2.6a6.738 6.738 0 0 1-1.392 2.117 6.57 6.57 0 0 1-2.07 1.424 6.22 6.22 0 0 1-2.541.526Z" />
              <path fill="#8C97A0"
                d="M35.88 22.688c2.688 0 4.307-1.336 4.307-3.438v-.008c0-1.758-1-2.71-3.291-3.195l-1.191-.25c-1.33-.281-1.933-.75-1.933-1.547v-.008c0-.898.802-1.515 2.093-1.523 1.237 0 2.085.586 2.215 1.57l.015.094h1.886l-.008-.133c-.114-1.93-1.687-3.226-4.093-3.226-2.375 0-4.078 1.343-4.086 3.328v.007c0 1.68 1.07 2.711 3.238 3.172l1.184.25c1.42.305 1.993.758 1.993 1.602v.008c0 .968-.87 1.601-2.26 1.601-1.382 0-2.352-.601-2.497-1.57l-.016-.094H31.55l.008.117c.13 2.024 1.794 3.243 4.322 3.243ZM44.462 22.656c1.222 0 2.054-.578 2.474-1.46h.038v1.296h1.902v-8.281h-1.902v4.797c0 1.203-.695 2.008-1.787 2.008-1.084 0-1.619-.664-1.619-1.836V14.21h-1.901v5.352c0 1.921 1.015 3.093 2.795 3.093ZM53.066 22.633c1.07 0 1.97-.547 2.436-1.414h.046v1.273h1.902v-5.695c0-1.664-1.306-2.758-3.33-2.758-2.054 0-3.299 1.102-3.414 2.57l-.007.094h1.764l.015-.07c.122-.61.672-1.04 1.573-1.04.963 0 1.497.509 1.497 1.345v.57l-2.115.133c-1.963.125-3.078 1.008-3.078 2.476v.016c0 1.476 1.092 2.5 2.711 2.5Zm-.817-2.578v-.008c0-.656.512-1.07 1.451-1.133l1.848-.117v.625c0 .984-.825 1.726-1.917 1.726-.832 0-1.382-.414-1.382-1.093ZM62.638 22.492h1.902V11.22h-1.902v11.273ZM69.975 22.656c2.375 0 3.918-1.617 3.918-4.304v-.016c0-2.672-1.566-4.297-3.925-4.297-2.353 0-3.91 1.64-3.91 4.297v.016c0 2.68 1.534 4.304 3.917 4.304Zm.008-1.57c-1.215 0-1.986-.992-1.986-2.734v-.016c0-1.719.787-2.719 1.97-2.719 1.207 0 1.986.992 1.986 2.719v.016c0 1.734-.771 2.734-1.97 2.734ZM79 25.39c2.344 0 3.818-1.257 3.818-3.132V14.21h-1.901v1.406h-.046c-.459-.953-1.344-1.578-2.49-1.578-2.047 0-3.368 1.61-3.368 4.227v.008c0 2.578 1.306 4.171 3.337 4.171 1.161 0 2.078-.562 2.528-1.445h.038v1.195c0 1.055-.68 1.727-1.916 1.727-.993 0-1.642-.36-1.848-.836l-.023-.063h-1.871l.015.07c.229 1.298 1.58 2.298 3.727 2.298Zm-.054-4.445c-1.222 0-1.993-1.007-1.993-2.64v-.008c0-1.61.771-2.617 1.993-2.617 1.176 0 1.978 1.023 1.978 2.625v.008c0 1.609-.794 2.632-1.978 2.632ZM88.192 22.656c2.375 0 3.918-1.617 3.918-4.304v-.016c0-2.672-1.566-4.297-3.925-4.297-2.353 0-3.91 1.64-3.91 4.297v.016c0 2.68 1.534 4.304 3.917 4.304Zm.008-1.57c-1.215 0-1.986-.992-1.986-2.734v-.016c0-1.719.787-2.719 1.97-2.719 1.207 0 1.986.992 1.986 2.719v.016c0 1.734-.771 2.734-1.97 2.734Z" />
              <rect width="70.544" height="23.515" x="319.728" y="6.243" fill={`#${bgColor}`} rx="1.641" />
              <path fill={`#${textColor}`}
                d="M337.981 22h3.255c1.547 0 2.507-.799 2.507-2.07v-.01c0-.929-.698-1.647-1.658-1.723v-.09c.744-.11 1.311-.779 1.311-1.542v-.01c0-1.115-.839-1.804-2.245-1.804h-3.17V22Zm2.783-6.123c.723 0 1.14.351 1.14.939v.01c0 .598-.447.94-1.266.94h-1.14v-1.89h1.266Zm.05 2.888c.894 0 1.382.362 1.382 1.035v.01c0 .688-.473 1.06-1.347 1.06h-1.351v-2.105h1.316Zm7.371 3.42c2.14 0 3.487-1.466 3.487-3.807v-.01c0-2.34-1.352-3.802-3.487-3.802-2.134 0-3.491 1.456-3.491 3.802v.01c0 2.341 1.336 3.808 3.491 3.808Zm0-1.285c-1.195 0-1.944-.99-1.944-2.522v-.01c0-1.537.764-2.516 1.944-2.516 1.176 0 1.939.979 1.939 2.516v.01c0 1.532-.758 2.522-1.939 2.522Zm6.337 1.1h1.517v-5.998h2.175v-1.25h-5.867v1.25h2.175V22Zm7.738-7.992c.718 0 1.19-.593 1.19-1.482v-.03h-.884v.015c0 .392-.125.608-.372.608-.125 0-.231-.035-.412-.211l-.09-.075c-.266-.242-.517-.342-.829-.342-.718 0-1.19.593-1.19 1.482v.03h.884v-.015c0-.397.125-.608.371-.608.126 0 .237.04.407.211l.096.075c.266.242.512.342.829.342ZM358.156 22h1.592l.538-1.758h2.556L363.38 22h1.597l-2.521-7.249h-1.784L358.156 22Zm3.365-5.802h.091l.884 2.909h-1.864l.889-2.909Zm7.427 5.988c2.14 0 3.486-1.467 3.486-3.808v-.01c0-2.34-1.351-3.802-3.486-3.802-2.135 0-3.492 1.456-3.492 3.802v.01c0 2.341 1.337 3.808 3.492 3.808Zm0-1.286c-1.196 0-1.944-.99-1.944-2.522v-.01c0-1.537.763-2.516 1.944-2.516 1.175 0 1.939.979 1.939 2.516v.01c0 1.532-.759 2.522-1.939 2.522Z" />
              <rect width="130.178" height="10.014" x="136" y="13.35" fill="#D5DFE8" rx="1.878" />
            </g>
            <g filter="url(#d)">
              <rect width="296" height="353" x="53" y="49" fill="#fff" rx="2.217" />
              <rect width="223.162" height="11.823" x="89.947" y="118.971" fill="#D5DFE8" rx="2.217" />
              <rect width="223.162" height="11.823" x="89.947" y="138.183" fill="#D5DFE8" rx="2.217" />
              <rect width="223.162" height="11.823" x="89.947" y="157.396" fill="#D5DFE8" rx="2.217" />
              <rect width="152.962" height="11.823" x="89.947" y="176.609" fill="#D5DFE8" rx="2.217" />
              <rect width="116.984" height="11.823" x="89.947" y="77.59" fill="#D5DFE8" rx="2.217" />
              <rect width="116.984" height="11.823" x="90" y="274" fill="#D5DFE8" rx="2.217" />
              <rect width="223.162" height="11.823" x="89.947" y="212.078" fill="#D5DFE8" rx="2.217" />
              <rect width="152.962" height="11.823" x="89.947" y="231.291" fill="#D5DFE8" rx="2.217" />
            </g>
          </g>
          <rect width="401" height="305" x=".5" y=".5" stroke="#D5DFE8" rx="2.5" />
          <defs>
            <clipPath id="a">
              <rect width="402" height="306" fill="#fff" rx="3" />
            </clipPath>
            <clipPath id="b">
              <path fill="#fff" d="M0 0h402v36H0z" />
            </clipPath>
            <filter id="d" width="298.956" height="355.956" x="51.522" y="48.261" colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dy=".739" />
              <feGaussianBlur stdDeviation=".739" />
              <feColorMatrix values="0 0 0 0 0.333333 0 0 0 0 0.4 0 0 0 0 0.466667 0 0 0 0.12 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_944_24634" />
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_944_24634" result="shape" />
            </filter>
          </defs>
        </svg>
        : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 300 354" width="300">
          <g filter="url(#a)">
            <rect width="296" height="350" x="2" y="1" fill="#fff" rx="2.217" />
            <rect width="107.886" height="29.735" x="37.947" y="279.582" fill={`#${bgColor}`} rx="4" />
            <path fill={`#${textColor}`}
              d="M74.972 298.449h3.273c1.556 0 2.521-.803 2.521-2.081v-.01c0-.934-.702-1.657-1.667-1.733v-.09c.748-.112 1.319-.783 1.319-1.551v-.01c0-1.122-.844-1.814-2.259-1.814h-3.187v7.289Zm2.799-6.157c.727 0 1.146.353 1.146.944v.01c0 .602-.45.945-1.273.945h-1.146v-1.899h1.273Zm.05 2.904c.9 0 1.39.364 1.39 1.041v.01c0 .692-.476 1.066-1.355 1.066h-1.358v-2.117h1.323Zm7.334 3.44c2.152 0 3.506-1.475 3.506-3.829v-.01c0-2.354-1.359-3.824-3.506-3.824s-3.51 1.465-3.51 3.824v.01c0 2.354 1.343 3.829 3.51 3.829Zm0-1.293c-1.202 0-1.955-.995-1.955-2.536v-.01c0-1.545.768-2.531 1.955-2.531 1.182 0 1.95.986 1.95 2.531v.01c0 1.541-.763 2.536-1.95 2.536Zm6.294 1.106h1.525v-6.031h2.187v-1.258h-5.9v1.258h2.188v6.031Zm7.703-8.036c.722 0 1.197-.596 1.197-1.491v-.03h-.89v.015c0 .394-.126.612-.373.612-.126 0-.233-.036-.414-.213l-.091-.075c-.268-.243-.52-.344-.834-.344-.722 0-1.197.596-1.197 1.49v.031h.89v-.016c0-.399.125-.611.373-.611.126 0 .237.041.409.212l.096.076c.268.243.515.344.834.344Zm-4.127 8.036h1.6l.541-1.768h2.572l.54 1.768h1.606l-2.535-7.289h-1.794l-2.53 7.289Zm3.384-5.834h.09l.89 2.925h-1.874l.894-2.925Zm7.39 6.021c2.151 0 3.505-1.475 3.505-3.829v-.01c0-2.354-1.359-3.824-3.505-3.824-2.147 0-3.511 1.465-3.511 3.824v.01c0 2.354 1.344 3.829 3.511 3.829Zm0-1.293c-1.203 0-1.955-.995-1.955-2.536v-.01c0-1.545.768-2.531 1.955-2.531 1.182 0 1.949.986 1.949 2.531v.01c0 1.541-.762 2.536-1.949 2.536Z" />
            <rect width="223.162" height="11.823" x="38.947" y="119.971" fill="#D5DFE8" rx="2.217" />
            <rect width="223.162" height="11.823" x="38.947" y="139.183" fill="#D5DFE8" rx="2.217" />
            <rect width="223.162" height="11.823" x="38.947" y="158.396" fill="#D5DFE8" rx="2.217" />
            <rect width="152.962" height="11.823" x="38.947" y="177.609" fill="#D5DFE8" rx="2.217" />
            <rect width="116.984" height="11.823" x="38.947" y="78.59" fill="#D5DFE8" rx="2.217" />
            <rect width="223.162" height="11.823" x="38.947" y="213.078" fill="#D5DFE8" rx="2.217" />
            <rect width="152.962" height="11.823" x="38.947" y="232.291" fill="#D5DFE8" rx="2.217" />
            <path fill="#fff"
              d="M46.337 52.728a7.191 7.191 0 0 1-2.882-.583 7.457 7.457 0 0 1-2.346-1.579 7.458 7.458 0 0 1-1.58-2.346 7.192 7.192 0 0 1-.582-2.882c0-1.022.194-1.983.583-2.882.387-.899.914-1.68 1.579-2.346a7.468 7.468 0 0 1 2.346-1.58 7.2 7.2 0 0 1 2.882-.581 7.2 7.2 0 0 1 2.882.581 7.468 7.468 0 0 1 2.346 1.58 7.456 7.456 0 0 1 1.579 2.346c.388.9.582 1.86.582 2.882a7.192 7.192 0 0 1-.582 2.882 7.456 7.456 0 0 1-1.58 2.346 7.456 7.456 0 0 1-2.345 1.58c-.9.388-1.86.582-2.882.582Z" />
            <path fill="#8C97A0"
              d="m45.302 48.737 5.21-5.21-1.035-1.034-4.175 4.175-2.106-2.106-1.034 1.035 3.14 3.14Zm1.035 3.99a7.191 7.191 0 0 1-2.882-.581 7.457 7.457 0 0 1-2.346-1.58 7.458 7.458 0 0 1-1.58-2.346 7.192 7.192 0 0 1-.582-2.882c0-1.022.194-1.983.583-2.882.387-.899.914-1.68 1.579-2.346a7.468 7.468 0 0 1 2.346-1.58 7.2 7.2 0 0 1 2.882-.581 7.2 7.2 0 0 1 2.882.581 7.468 7.468 0 0 1 2.346 1.58 7.456 7.456 0 0 1 1.579 2.346c.388.9.582 1.86.582 2.882a7.192 7.192 0 0 1-.582 2.882 7.456 7.456 0 0 1-1.58 2.346 7.456 7.456 0 0 1-2.345 1.58c-.9.388-1.86.582-2.882.582Z" />
            <path fill="#8C97A0"
              d="M64.548 50.618c3.048 0 4.884-1.48 4.884-3.81V46.8c0-1.949-1.135-3.005-3.732-3.542l-1.351-.277c-1.507-.312-2.191-.832-2.191-1.715v-.009c0-.995.91-1.68 2.373-1.688 1.402 0 2.364.65 2.51 1.74l.018.104h2.14l-.01-.147c-.13-2.139-1.913-3.576-4.641-3.576-2.693 0-4.624 1.49-4.633 3.689v.008c0 1.862 1.212 3.005 3.672 3.516l1.342.277c1.61.338 2.26.84 2.26 1.775v.009c0 1.074-.987 1.775-2.563 1.775-1.568 0-2.667-.666-2.832-1.74l-.017-.104h-2.14l.01.13c.147 2.242 2.035 3.593 4.9 3.593ZM74.279 50.584c1.385 0 2.33-.641 2.806-1.62h.043v1.438h2.156v-9.18h-2.156v5.318c0 1.333-.788 2.225-2.026 2.225-1.23 0-1.836-.736-1.836-2.035v-5.507h-2.157v5.931c0 2.13 1.152 3.43 3.17 3.43ZM84.036 50.558c1.212 0 2.234-.606 2.762-1.568h.052v1.412h2.156v-6.313c0-1.844-1.48-3.057-3.775-3.057-2.33 0-3.741 1.221-3.871 2.85l-.009.103h2l.018-.078c.138-.675.762-1.151 1.784-1.151 1.09 0 1.697.562 1.697 1.489v.632l-2.399.147c-2.225.139-3.49 1.117-3.49 2.745v.018c0 1.636 1.239 2.77 3.075 2.77Zm-.927-2.858v-.009c0-.727.58-1.186 1.645-1.255l2.096-.13v.693c0 1.09-.935 1.913-2.173 1.913-.944 0-1.568-.459-1.568-1.212ZM94.89 50.402h2.156V37.906H94.89v12.496ZM103.209 50.584c2.693 0 4.443-1.793 4.443-4.772v-.017c0-2.962-1.776-4.763-4.451-4.763-2.668 0-4.434 1.819-4.434 4.763v.017c0 2.97 1.741 4.772 4.442 4.772Zm.009-1.74c-1.377 0-2.252-1.1-2.252-3.032v-.017c0-1.905.892-3.014 2.235-3.014 1.368 0 2.251 1.1 2.251 3.014v.017c0 1.923-.875 3.031-2.234 3.031ZM113.442 53.615c2.659 0 4.33-1.395 4.33-3.473v-8.92h-2.156v1.56h-.052c-.52-1.057-1.524-1.75-2.823-1.75-2.321 0-3.819 1.784-3.819 4.685v.009c0 2.857 1.481 4.624 3.784 4.624 1.317 0 2.356-.624 2.867-1.602h.043v1.325c0 1.169-.771 1.914-2.174 1.914-1.125 0-1.861-.399-2.095-.927l-.026-.07h-2.122l.018.079c.259 1.437 1.792 2.546 4.225 2.546Zm-.06-4.928c-1.386 0-2.26-1.117-2.26-2.927v-.008c0-1.784.874-2.901 2.26-2.901 1.333 0 2.243 1.134 2.243 2.91v.008c0 1.784-.901 2.918-2.243 2.918ZM123.866 50.584c2.693 0 4.442-1.793 4.442-4.772v-.017c0-2.962-1.775-4.763-4.451-4.763-2.667 0-4.433 1.819-4.433 4.763v.017c0 2.97 1.74 4.772 4.442 4.772Zm.009-1.74c-1.377 0-2.252-1.1-2.252-3.032v-.017c0-1.905.892-3.014 2.234-3.014 1.369 0 2.252 1.1 2.252 3.014v.017c0 1.923-.875 3.031-2.234 3.031Z" />
          </g>
          <defs>
            <filter id="a" width="298.956" height="352.956" x=".522" y=".261" colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dy=".739" />
              <feGaussianBlur stdDeviation=".739" />
              <feColorMatrix values="0 0 0 0 0.333333 0 0 0 0 0.4 0 0 0 0 0.466667 0 0 0 0.12 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_944_24609" />
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_944_24609" result="shape" />
            </filter>
          </defs>
        </svg>
      }
    </div>
  )
}

export default BrandTab;